import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";

const Container = styled.div`
	display: flex;
	background: ${MAIN_THEME.DARK_BG};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.45);
	border-radius: 16px;
	width: min(980px, 90vw);
	height: min(720px, 80vh);
	overflow: hidden;

	@media (max-width: 768px) {
		width: 100vw;
		height: 100vh;
		border-radius: 0;
		border-left: none;
		border-right: none;
		border-bottom: none;
	}
`;

interface Props {
	children?: JSX.Element | Array<JSX.Element>;
}

const AuthFormContainer = (props: Props): JSX.Element => {
	const { children } = props;

	return <Container>{children}</Container>;
};

export default AuthFormContainer;
